<template>
  <section>
    <!--工具条-->
    <el-form :inline="true" :model="dataForm" ref="lineForm">
      <el-form-item label="分公司名称:" prop="name">
        <el-input
          v-model="dataForm.name"
          placeholder="请输入分公司名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          v-permission="['/BaseData/TenantManagement/Search']"
          @click="getDataList()"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          v-permission="['/BaseData/TenantManagement/Add']"
          @click="addOrUpdateHandle()"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      :data="dataList"
      v-loading="dataListLoading"
      ref="table"
      class="custom-tbl"
      style="width: 100%"
    >
      <!-- <el-table-column type="selection" width="50"> </el-table-column> -->
      <!-- <el-table-column type="index" width="80"> </el-table-column> -->
      <el-table-column
        align="center"
        prop="Id"
        label="ID"
        width="250"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="Name"
        label="名称"
      ></el-table-column>
      <el-table-column prop="Status" label="状态" width="80" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Status ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.Status ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        width="300"
        align="center"
        prop="CrmUrl"
        label="CRM域名"
      ></el-table-column>
      <el-table-column
        width="200"
        align="center"
        prop="Remark"
        label="备注"
      ></el-table-column>

      <el-table-column label="操作" width="250" fixed="right">
        <template scope="scope">
          <el-button
            size="small"
            v-permission="['/BaseData/TenantManagement/Edit']"
            @click="addOrUpdateHandle(scope.row.Id)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            size="small"
            v-permission="['/BaseData/TenantManagement/Delete']"
            @click="deleteHandle(scope.row.Id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
        :current-page="page"
        :page-sizes="pageSizes"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="float: right; margin-top: 15px"
      >
      </el-pagination> -->
    <addOrUpdate ref="addOrUpdate" @ok="query"></addOrUpdate>
  </section>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addOrUpdate from "./components/TenantManagementAddOrUpdate.vue";
import { read, utils } from "xlsx";
export default {
  components: { addOrUpdate },
  mixins: [viewModule],
  data() {
    return {
      dataForm: {
        name: "",
      },
      mixinViewModuleOptions: {
        requestMethod: "get",
        getDataListIsPage: false,
        getDataListURL: "/api/TenantManager/GetAll",
        deleteURL: "/api/TenantManager/Delete",
      },
    };
  },
  methods: {},
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
